"use client";

import React, { useRef, useState } from "react";
import { Icon } from "@/global-components/Icon";
import { ChevronDown } from "lucide-react";
import clsx from "clsx";

function KeyOfferingItem({ offering, index }) {
  const [isOpen, setIsOpen] = useState(false);
  const contentRef = useRef(null);

  const toggle = () => setIsOpen(!isOpen);

  return (
    <div
      key={index}
      className="mb-5 p-8 shadow-2xl bg-neutral-50 border-2 border-solid rounded-sm"
    >
      <div
        onClick={toggle}
        className="flex items-center justify-between cursor-pointer"
      >
        <div className="flex items-center gap-4">
          <Icon name={offering.icon} size={50} />
          <p className="font-bold text-2xl">{offering.offering}</p>
        </div>
        <ChevronDown
          className={clsx("transition-transform duration-300", {
            "rotate-180": isOpen,
          })}
        />
      </div>

      <div
        ref={contentRef}
        style={{
          height: isOpen ? `${contentRef.current?.scrollHeight}px` : "0px",
        }}
        className="overflow-hidden transition-all duration-500 ease-in-out"
      >
        <p className="font-mono mt-4">{offering.offeringDescription}</p>
      </div>
    </div>
  );
}

export default function KeyOfferings({ items = [] }) {
  return (
    <div className="grid">
      {items.map((offering, index) => (
        <KeyOfferingItem offering={offering} index={index} key={index} />
      ))}
    </div>
  );
}
